import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppBubble.css";

export default function WhatsAppBubble() {
    const [config, setConfig] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const unsub = onSnapshot(doc(db, "siteConfig", "general"), (snap) => {
            if (snap.exists()) {
                const data = snap.data();
                setConfig(data);
                if (data.whatsappEnabled && data.whatsappNumber) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            }
        });
        return () => unsub();
    }, []);

    if (!show || !config) return null;

    // Clean number: remove non-digits
    const cleanNumber = config.whatsappNumber.replace(/\D/g, "");
    const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(config.whatsappMessage || "")}`;

    return (
        <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="whatsapp-bubble"
            title="Message us on WhatsApp"
        >
            <FaWhatsapp size={30} />
        </a>
    );
}
